import { ConfigRepository } from '~repositories/ConfigRepository';

import { RampFormStore } from './RampFormStore';

export interface IGuestSignInFormValues {
    newUserEmailAddress: string;
    pcEmailPromotions?: number;
}

export class GuestSignInFormStore extends RampFormStore<IGuestSignInFormValues> {
    constructor(configRepository: ConfigRepository) {
        const initialValues = configRepository.getFormInitialValues({
            configName: 'guestCheckout',
            defaultValues: { newUserEmailAddress: '', pcEmailPromotions: 1 }
        });

        super(initialValues);
    }
}
